import React, { useEffect, useState } from 'react';
import PreSignupForm from '../pre_signup';
import DropdownInput from '../../../ui_kit/utilities/dropdown_input';
import { getAccounts } from '../../../../api/v2/accounts';

import styles from './index.module.css';

const PreSignupPicker = () => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState('');
  const [shouldShowPreSignupForm, setShouldShowPreSignupForm] = useState(false);

  useEffect(() => {
    getAccounts((accounts) => {
      setOptions(
        accounts
          .filter((a) => a.pre_sign_up_eligible)
          .flatMap((a) =>
            a.account_conditions.map((condition) => ({
              condition,
              treatment_retention_url: a.treatment_retention_url,
            }))
          )
          .filter((item, index, self) => index === self.findIndex((b) => b.condition === item.condition))
      );
    });
  }, []);

  const handleSubmit = () => {
    if (selected === 'Other') {
      setShouldShowPreSignupForm(true);
      return;
    }
    const option = options.find((o) => o.condition === selected);
    if (option) {
      window.location.href = option.treatment_retention_url;
    }
  };

  const dropdownOptions = [...options.map((o) => ({ value: o.condition })), { value: 'Other' }];

  if (shouldShowPreSignupForm) {
    return <PreSignupForm />;
  }

  return (
    <div className={styles.page_wrapper}>
      <div className='container'>
        <div className='row justify-content-center'>
          <div className={`col-md-6 col-12 ${styles.picker_container}`}>
            <h5 className='text-center marg-bottom-10'>Select your condition to connect with a mentor</h5>
            <p>If you do not see your condition listed, please choose "Other"</p>
            <div className={styles.dropdown_wrapper}>
              <DropdownInput
                values={selected}
                options={dropdownOptions}
                setValues={setSelected}
                wrapperClassname={styles.dropdown}
                marginTop='6px'
                type='single'
                placeholder='Choose a condition'
              />
            </div>
            <div className={styles.button_wrapper}>
              <button className='submit marg-top-20' onClick={handleSubmit} disabled={!selected}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreSignupPicker;
